import { ExternalLink, Eye, EyeOff } from "lucide-react";

export const LeagueDetailsSection = ({ league, onToggleMenuVisibility }) => (
  <div className="space-y-6">
    {/* Public Page Link */}
    <div className="bg-orange-500/10 border border-orange-500/30 rounded-lg p-4 flex items-center justify-between">
      <div>
        <p className="text-orange-400 font-medium">Public League Page</p>
        <p className="text-zinc-400 text-sm">/league/{league.slug}</p>
      </div>
      <a
        href={`/league/${league.slug}`}
        target="_blank"
        rel="noopener noreferrer"
        className="px-4 py-2 bg-orange-500 text-white rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors flex items-center gap-2"
      >
        <ExternalLink className="w-4 h-4" />
        View Page
      </a>
    </div>

    <div className="grid grid-cols-2 gap-6">
      <div>
        <label className="text-xs text-zinc-500 uppercase">League Name</label>
        <p className="text-white font-medium">{league.name}</p>
      </div>
      <div>
        <label className="text-xs text-zinc-500 uppercase">Abbreviation</label>
        <p className="text-white font-medium">{league.abbreviation || "-"}</p>
      </div>
      <div>
        <label className="text-xs text-zinc-500 uppercase">Sport</label>
        <p className="text-white font-medium">{league.sport || "-"}</p>
      </div>
      <div>
        <label className="text-xs text-zinc-500 uppercase">Season</label>
        <p className="text-white font-medium">{league.season || "-"}</p>
      </div>
      <div>
        <label className="text-xs text-zinc-500 uppercase">URL Slug</label>
        <p className="text-zinc-400 font-mono text-sm">/league/{league.slug}</p>
      </div>
      <div>
        <label className="text-xs text-zinc-500 uppercase mb-2 block">Show in Menu</label>
        <button
          onClick={() => onToggleMenuVisibility && onToggleMenuVisibility(league)}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
            league.show_in_menu 
              ? 'bg-green-500/20 text-green-400 hover:bg-green-500/30' 
              : 'bg-zinc-800 text-zinc-400 hover:bg-zinc-700'
          }`}
          data-testid="league-menu-visibility-toggle"
        >
          {league.show_in_menu ? (
            <>
              <Eye className="w-4 h-4" />
              Visible
            </>
          ) : (
            <>
              <EyeOff className="w-4 h-4" />
              Hidden
            </>
          )}
        </button>
      </div>
    </div>
    {league.description && (
      <div>
        <label className="text-xs text-zinc-500 uppercase">Description</label>
        <p className="text-zinc-300 mt-1">{league.description}</p>
      </div>
    )}
    
    {/* Ad Banners Summary */}
    {league.ad_banners && league.ad_banners.length > 0 && (
      <div className="border-t border-zinc-800 pt-6">
        <h4 className="text-sm font-bold text-zinc-400 uppercase mb-4">Ad Banners ({league.ad_banners.length})</h4>
        <div className="grid grid-cols-3 gap-3">
          {league.ad_banners.map((banner, idx) => (
            <div key={idx} className="bg-zinc-800/50 rounded-lg p-3">
              <img 
                src={banner.image_url} 
                alt={banner.alt_text || "Ad"} 
                className="w-full h-16 object-cover rounded mb-2"
              />
              <div className="flex items-center justify-between">
                <span className="text-xs text-zinc-400 capitalize">{banner.position.replace("_", " ")}</span>
                <span className={`text-xs px-2 py-0.5 rounded ${
                  banner.is_active ? "bg-green-500/20 text-green-400" : "bg-zinc-700 text-zinc-500"
                }`}>
                  {banner.is_active ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
    
    {league.seo && (league.seo.meta_title || league.seo.meta_description) && (
      <div className="border-t border-zinc-800 pt-6">
        <h4 className="text-sm font-bold text-zinc-400 uppercase mb-4">SEO Settings</h4>
        <div className="space-y-3">
          {league.seo.meta_title && (
            <div>
              <label className="text-xs text-zinc-500">Meta Title</label>
              <p className="text-zinc-300">{league.seo.meta_title}</p>
            </div>
          )}
          {league.seo.meta_description && (
            <div>
              <label className="text-xs text-zinc-500">Meta Description</label>
              <p className="text-zinc-300">{league.seo.meta_description}</p>
            </div>
          )}
        </div>
      </div>
    )}
  </div>
);
